<template>
  <div class="app-main-inner-page">
    <el-dialog
      :visible.sync="innerVisible"
      :title="title"
      :width="$selectByLang('1050px', '1070px','1070px','1270px','1170px','1170px')"
      :close-on-click-modal="false"
      :show-close="false"
      top="5vh"
      class="make-invoice-step-one-dialog"
    >
      <div class="app-main-inner-row" style="padding-top: 0;">
        <el-form :label-width="$selectByLang('90px', '110px')" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_invoicingMethod')">
              <span style="font-size: 14px;">{{ invoicingMethod }}</span>
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="isCollectInvoice ? $t('Invoice.invoice_CollectInvoiceType') : $t('Invoice.invoice_invoicingType')" />
              <el-radio-group v-model="properties.typeGroup" no="typeGroup" class="custom-radio-group">
                <el-radio label="multi" :disabled="properties.isHedge">{{ isCollectInvoice ? $t('Invoice.invoice_consolidatedInvoiceCollect') : $t('Invoice.invoice_consolidatedInvoice') }}</el-radio>
                <el-radio label="settlementAgent" :disabled="properties.isHedge || properties.toExoSystemHC">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToSettlementAgentCollect') : $t('Invoice.invoice_invoicingAccordingToSettlementAgent') }}</el-radio>
                <el-radio label="job" :disabled="properties.isHedge || properties.toExoSystemHC">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToBusinessCollect') : $t('Invoice.invoice_invoicingAccordingToBusiness') }}</el-radio>
                <el-radio label="single" :disabled="properties.isHedge || (properties.toExoSystemHC && !properties.isAr)">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToRecordsCollect') : $t('Invoice.invoice_invoicingAccordingToRecords') }}</el-radio>
                <!-- 在账单(bill)、对账单(billGroup)和开票模块(invoice)中隐藏 "按抬头开票" 选项 -->
                <el-radio v-if="shouldShowTitleOption()" label="title" :disabled="properties.isHedge">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToTitleCollect') : $t('Invoice.invoice_invoicingAccordingToTitle') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Invoice.invoice_makeType')">
              <el-radio-group v-model="properties.groupingMakeType" no="groupingMakeType" @change="changeInvoiceType">
                <el-radio :label="0" :disabled="(properties.invoiceType===6 || properties.invoiceType===7 || properties.isEasyInoivceVietnam)">{{ $t('Invoice.invoice_makePaper') }}</el-radio>
                <el-radio :label="1" :disabled="properties.invoiceType!==2 && properties.invoiceType!==3">{{ $t('Invoice.invoice_makeElectronic') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Invoice.invoice_invoiceType')">
              <el-select v-model="properties.invoiceType" no="invoiceType" style="width:175px;" @change="invoiceTypeChange">
                <el-option
                  v-for="item in invoiceTypeOptions"
                  :key="item.code"
                  :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="(properties.invoiceType===6 || properties.invoiceType===7)" :label="$t('Invoice.SpecificConstraintTypes')">
              <el-select v-model="properties.specificConstraintType" :disabled="restrictionHC" style="width:175px;">
                <el-option
                  v-for="item in InvoiceConstant.SPECIFIC_CONSTRAINT_TYPES"
                  :key="item.code"
                  :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToCurrencyCollect') : $t('Invoice.invoice_invoicingAccordingToCurrency')" />
              <el-radio-group v-model="properties.currencyGroup" no="currencyGroup">
                <div class="inlineWarp" style="margin-bottom: 10px;">
                  <el-radio no="invoicingPerCurrency" :label="0">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingPerCurrencyCollect') : $t('Invoice.invoice_invoicingPerCurrency') }}</el-radio>
                  <el-checkbox v-model="properties.cbAssignCurrency" :disabled="properties.currencyGroup===1" no="cbAssignCurrency">{{ $t('Invoice.invoice_specifyInvoiceCurrency') }}</el-checkbox>
                </div>
                <el-radio v-if="!properties.settlementCenterMode" no="consolidatedCurrency" :label="1" :disabled="properties.isEasyInoivceVietnam">{{ $t('Invoice.invoice_consolidatedCurrency') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="isCollectInvoice ? $t('Invoice.invoice_invoicingCurrencyCollect') : $t('Invoice.invoice_invoicingCurrency')" />
              <cargo-advance-select
                no="currency"
                filterable
                :select-type="TYPE_NAMES.basic_data_Currency"
                :default-value="properties.currency"
                style="width:175px;"
                :clearable="false"
                :disabled="(properties.allowModifyCurrency === false) || !((properties.currencyGroup === 0 && properties.cbAssignCurrency) || properties.currencyGroup === 1)"
                @parentCallBack="currencyChangeEvent"
              />
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="$t('Invoice.invoice_settleDepartmentPrefix')" />
              <cargo-department-select
                no="settleDepartment"
                :office-id="Number($store.getters.currentOfficeId)"
                :department-id="Number(properties.settleDepartment)"
                style="width:175px;"
                @change="settleDepartmentChangeEvent"
              />
            </el-form-item>
          </div>
        </el-form>
        <div style="width: 640px;">
          <div class="app-main-inner-row">
            <span style="font-size: 14px;">{{ $t('CargoMsg.Cargo_InvoiceItemNameSetup') }}</span>
          </div>
          <div v-if="viewSource!=='overseaBilling'&&viewSource!=='internalBillInfo'" class="app-main-inner-row">
            <div class="triggers">
              <el-button type="primary" no="toAdd" @click="toAdd">{{ $t('common.btn.new') }}</el-button>
              <el-button type="primary" no="toEdit" :disabled="isEditing" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
              <el-button type="danger" no="toDelete" :disabled="isEditing" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
              <el-button type="primary" no="doDefaultSetting" :disabled="isEditing" :style="$selectByLang('', 'margin-top: 5px;')" @click="doDefaultSetting">{{ $t('CargoMsg.Cargo_SetDefaultItemDescription') }}</el-button>
              <el-button type="primary" no="needSave" :disabled="!needSave" @click="toSave">{{ $t('common.btn.save') }}</el-button>
              <el-dropdown
                v-if="properties.isEasyInoivceVietnam"
                split-button
                type="primary"
                style="padding-left: 5px;"
                @click="btnSetupHandler()"
                @command="p=>{commandCode=p;btnSetupHandler()}"
              >
                {{ commandCode }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="$t('CargoMsg.Cargo_InvoiceChargeItemSetup')" no="invoiceChargeItemSetup">{{ $t('CargoMsg.Cargo_InvoiceChargeItemSetup') }}</el-dropdown-item>
                  <el-dropdown-item :command="$t('CargoMsg.Cargo_InvoiceChargeUnitSetup')" no="invoiceChargeUnitSetup">{{ $t('CargoMsg.Cargo_InvoiceChargeUnitSetup') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="app-main-inner-row row-grid" style="height: 260px;padding-left: 10px;padding-right: 6px;">
            <cargo-ag-grid
              config-module="20220416"
              :grid-params.sync="invoiceGoodsName.gridParams"
              :grid-options="invoiceGoodsName.gridOptions"
              :column-defs="invoiceGoodsNameColumnDefs"
              :row-data="invoiceGoodsNameRowData"
              style="width: 100%;flex:1"
              @gridReady="params=>gridApi=params.api"
            />
          </div>
          <span style="color: red;padding-left: 10px;padding-right: 6px;">{{ $t('CargoMsg.Cargo_TaxRevenueToolTip') }}</span>
        </div>
      </div>
      <!-- 合并：费用合计 + 可编辑折合汇率 + 操作按钮，统一放在底部 footer 栏（布局：合计 → 汇率 → … → 取消/确认开票） -->
      <div slot="footer" style="display:flex; justify-content:space-between; align-items:center; width:100%; flex-wrap:wrap;">
        <div style="display:flex; align-items:center; flex:1; flex-wrap:wrap; padding-right:10px; font-size:13px;">
          <span style="margin-right:4px;" v-text="$t('Invoice.invoice_total')" />
          <span style="margin-right:4px; font-weight:bold;">{{ totalDisplayText }}</span>
          <charge-currency-total-group
            v-if="reCalc"
            :key="3"
            style="display:none;"
            mode="group"
            type="revenueAbs"
            data-field="amount"
            rate-field="invoiceRate"
            currency-field="currency"
            source="invoiceDetail"
            :ar-field="arField"
            :data-provider="invoiceCharges"
            :amount-to-currency="properties.currency"
            :currency-conversion-in-invoices="currencyConversionInInvoices"
            @callback="onTotalCallback"
          />
          <template v-if="properties.txtCurrency1!==''">
            <span style="margin-left:12px;">{{ $t('Invoice.invoice_currency') }}&nbsp;&nbsp;<b>{{ properties.txtCurrency1 }}<i class="el-icon-right" />{{ properties.currency }}</b></span>
            <span style="margin-left:8px;">{{ $t('Invoice.invoice_exchangeRate') }}</span>
            <num-input v-model="properties.txtRate1" no="txtRate1" :precision="8" :truncated-precision="txtRate1Precision" style="width: 95px;" @change="txtRate1Change" />
          </template>
          <template v-if="properties.txtCurrency2!==''">
            <span style="margin-left:12px;">{{ $t('Invoice.invoice_currency') }}&nbsp;&nbsp;<b>{{ properties.txtCurrency2 }}<i class="el-icon-right" />{{ properties.currency }}</b></span>
            <span style="margin-left:8px;">{{ $t('Invoice.invoice_exchangeRate') }}</span>
            <num-input v-model="properties.txtRate2" no="txtRate2" :precision="8" :truncated-precision="txtRate2Precision" style="width: 95px;" @change="txtRate2Change" />
          </template>
        </div>
        <div>
          <el-button no="autoSplitCharge" type="primary" @click="prepareChargeSplit('auto')">{{ $t('Invoice.AutoSplitCharge') }}</el-button>
          <el-button no="splitCharge" type="primary" @click="prepareChargeSplit('manual')">{{ $t('CargoMsg.Cargo_Sp31') }}</el-button>
          <el-button no="btnCancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
          <el-button no="invoice_next" type="primary" @click="toNext">{{ $t('Invoice.invoice_invoiceConfirmation') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  发票项目名称设置维护弹窗页  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="maintainDialog.show"
      :title="maintainDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="maintainDialog.maintainForm" label-width="140px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('Clearing.InvoiceType')">
            <el-select />
          </el-form-item>
          <el-form-item :label="$t('Clearing.RMBExpenseItemName')">
            <el-input />
          </el-form-item>
          <el-form-item :label="$t('Clearing.USDExpenseItem')">
            <el-input />
          </el-form-item>
          <el-form-item :label="$t('Clearing.TaxRate')">
            <el-input />
          </el-form-item>
          <el-form-item label="">
            <el-checkbox>{{ $t('Clearing.DefaultItemName') }}</el-checkbox>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button no="save" type="primary" @click="doSave">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="maintainDialog.show = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 开票-费用设置 -->
    <invoice-charge-item-window
      v-if="invoiceChargeItemDialog.visible"
      :visible.sync="invoiceChargeItemDialog.visible"
      :invoice-type="properties.invoiceType"
      @close="invoiceChargeItemDialog.visible=false"
    />
    <!-- 开票-单位设置 -->
    <invoice-charge-unit-window
      v-if="invoiceChargeUnitDialog.visible"
      :visible.sync="invoiceChargeUnitDialog.visible"
      :invoice-type="properties.invoiceType"
      @close="invoiceChargeUnitDialog.visible=false"
    />
    <el-dialog
      v-el-drag-dialog
      :visible.sync="splitChargeSelectDialog.visible"
      :title="$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit')"
      width="760px"
      :close-on-click-modal="false"
    >
      <el-table
        :data="splitChargeSelectDialog.rowData"
        height="320"
        highlight-current-row
        @current-change="row=>{splitChargeSelectDialog.currentRow = row}"
        @row-dblclick="row=>{splitChargeSelectDialog.currentRow = row; confirmChargeSplitSelection()}"
      >
        <el-table-column prop="jobNo" :label="$t('Invoice.invoice_businessNumber')" width="160" />
        <el-table-column prop="chargeName" :label="$t('CargoMsg.Cargo_ChargeName')" min-width="160" />
        <el-table-column prop="currency" :label="$t('CargoMsg.Cargo_Currency')" width="90" />
        <el-table-column prop="amount" :label="$t('Invoice.invoice_taxIncludedPrice')" width="120" />
        <el-table-column prop="taxRate" :label="$t('Invoice.billingJob_taxRate')" width="90" />
      </el-table>
      <div slot="footer">
        <el-button no="ok" type="primary" @click="confirmChargeSplitSelection">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="splitChargeSelectDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--  费用拆分弹窗页  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="splitChargeDialog.show"
      :title="$t('CargoMsg.Cargo_Sp31')"
      width="760px"
      class="make-invoice-step-two-split-charge-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        :inline="true"
        :model="splitChargeDialog.splitChargeForm"
        label-width="70px"
        label-position="right"
      >
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
            <span>{{ splitChargeDialog.charge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.charge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')">
            <span>{{ splitChargeDialog.charge.amount }}</span>
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_SplitExpenseP')">
            <span>{{ splitChargeDialog.splitCharge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.splitCharge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.amount"
              no="amount"
              :precision="2"
              controls-position="right"
              :controls="false"
              @change="amountChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxExcludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.excludingTaxAmount"
              no="excludingTaxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item label=" " />
          <el-form-item label=" " />
          <el-form-item :label="$t('CargoMsg.Cargo_TaxAmountP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxAmount"
              no="taxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxRateP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxRate"
              no="taxRate"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <span style="position: absolute; left: 0; padding-left: 10px;">
          <el-checkbox v-model="splitChargeDialog.onlyChangeQuantity" no="onlyChangeQuantity" @change="onlyChangeQuantityChangeHandler">{{ $t('Invoice.invoice_SplitChargeOnlyChangeQuantity') }}</el-checkbox>
        </span>
        <el-button no="ok" type="primary" :disabled="splitChargeDialog.btnSplitEnable" @click="doSplitCharge">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="splitChargeDialog.show = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 自动拆分费用弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="autoSplitChargeDialog.visible"
      :title="$t('Invoice.AutoSplitCharge')"
      width="630px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        :inline="true"
        :model="autoSplitChargeDialog.chargeOrigin"
        label-width="90px"
        label-position="right"
      >
        <div style="border-bottom: 1px solid #000000;height: 100px;">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.chargeName }}</span>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.currency }}</span>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.amount }}</span>
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('CargoMsg.Cargo_SplitExpenseP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.chargeName }}</span>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.currency }}</span>
            </el-form-item>
            <el-form-item :label="$t('Invoice.IncludingTaxAmountLimit')">
              <el-input-number
                v-model="autoSplitChargeDialog.maxAmount"
                :precision="2"
                controls-position="right"
                :controls="false"
                @change="p=>{autoSplitChargeDialog.confirmSplitEnable = true;maxAmountChangeHandler(p)}"
              />
            </el-form-item>
          </div>
          <div slot="footer" style="padding-bottom: 10px; float: right">
            <el-button no="toAutoCalculateSplit" type="primary" @click="toAutoCalculateSplit">{{ $t('Invoice.AutoCalculateSplit') }}</el-button>
          </div>
        </div>
        <div style="min-height: 310px;">
          <h1 style="font-size: 20px;">{{ $t('Invoice.AutoCalculateSplitResult') }}</h1>
          <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
            <span>{{ autoSplitChargeDialog.chargeOrigin.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ autoSplitChargeDialog.chargeOrigin.currency }}</span>
          </el-form-item>
          <div class="section grid-wrapper" style="min-height: 200px;">
            <cargo-ag-grid
              :grid-options="autoSplitChargeDialog.gridOptions"
              :column-defs="autoSplitChargeDialog.columnDefs"
              :row-data="autoSplitChargeDialog.rowData"
              :check-main-record="false"
              :deselect-main-record="false"
              :auto-fit-content="false"
              style="width: 100%;"
              @gridReady="params=>{autoSplitChargeDialog.gridApi=params.api}"
            />
          </div>
          <div slot="footer" style="float: right">
            <el-button type="primary" no="doAutoSplitCharge" :disabled="autoSplitChargeDialog.confirmSplitEnable" @click="doAutoSplitCharge">{{ $t('common.btn.ok') }}</el-button>
            <el-button no="autoSplitChargeDialogCancel" @click="autoSplitChargeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 合并自 Step2：多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :res-data="batchCheckingWindow.resData"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
    />
  </div>
</template>

<script>

import { getGridSelected } from '@/utils/agGrid'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { saveInvoiceGoodsName, deleteInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'
import { generateInvoiceFaster, saveInvoiceFasterFunc, saveSplitCharge } from '@/api/clearing/invoice'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import NumInput from '@/components/Cargo/Common/NumInput'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { checkChargeByInvoiceSaveNode } from '@/api/booking/job'
import { getObjectByCache, syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { loadCompanyRelated } from '@/api/company'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import lang from '@/lang'
import { roundHalfUp } from '@/utils/commonUtil'
import InvoiceChargeItemWindow from './invoiceChargeItemWindow'
import InvoiceChargeUnitWindow from './invoiceChargeUnitWindow'
import { mergeInvoiceSplitCharges } from './mergeInvoiceSplitCharges'

export default {
  name: 'MakeInvoiceStepOneDialog',
  components: { CargoAdvanceSelect, cargoDepartmentSelect, InvoiceChargeItemWindow, InvoiceChargeUnitWindow, ChargeCurrencyTotalGroup, NumInput, BatchCheckingWindow },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true, default: lang.t('Clearing.Invoice') },
    location: { type: String, default: '' },
    /**
     * params.mode: 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
     * params.paymentType: 收付方式[default:1] 1-应收开票 2-应付收票
     * params.makeInvoiceMethod: 开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单 5-付款申请模块收票弹窗
     * params.originMakeInvoiceMethod: 原始开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单
     */
    params: { type: Object, required: true },
    properties: { type: Object, required: true },
    viewSource: { type: String, default: '' } // 请求来源
  },
  data() {
    return {
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      makeInvoiceForm: {
        makeInvoiceType: 1,
        invoiceType: 1
      },
      invoiceGoodsName: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowHeight: 30,
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          defaultColDef: {
            filter: false
          }
        }
      },
      gridApi: null,
      isEditing: false, // 是否编辑
      needSave: false, // 是否需要保存
      maintainDialog: {
        show: false,
        isEdit: false,
        title: this.$t('Clearing.Add'),
        maintainForm: {
        }
      },
      makeInvoiceStepTwoDialog: {
        visible: false,
        title: this.$t('Clearing.Add'),
        params: {}
      },
      isFei: false, // 是否支持全电
      isNuoNuo: false, // 是否诺诺全电
      taxInvoiceConfigOptions: [], // 配置去重后的发票类型集合：仅用于默认值推导与日志，不再作为下拉数据源
      taxInvoiceConfigCombos: [], // 配置中的 (taxRate, invoiceType) 组合集合
      taxInvoiceConfigByCompany: {}, // 每个结算对象的「税率-发票类型配置」组合（taxRate→String、invoiceType→Number），批量按数据对应结算对象精确匹配
      taxInvoiceConfigLoaded: false, // 是否成功加载到配置数据
      taxInvoiceConfigRequestKey: '', // 已请求的结算对象+税率配对标识，防止重复请求
      taxInvoiceConfigBatchApplied: false, // 当前配置结果是否为批量式匹配（含单选一条数据下多税率场景），重放默认值时按 defaultType 重设
      taxInvoiceConfigDefaultType: null, // 批量式匹配的默认发票类型 code（税率最大值 9% 除外 / 用户确认统一类型）
      commandCode: this.$t('CargoMsg.Cargo_InvoiceChargeItemSetup'),
      restrictionHC: false, // 9 税率时，禁止修改 发票类型，发票类型
      invoiceChargeItemDialog: {
        visible: false
      },
      invoiceChargeUnitDialog: {
        visible: false
      },
      splitChargeSelectDialog: {
        visible: false,
        action: '',
        rowData: [],
        currentRow: null
      },
      selectedCharge: {},
      splitChargeDialog: {
        show: false,
        charge: {},
        chargeOrigin: {},
        splitCharge: {
          chargeName: '',
          currency: '',
          amount: 0.0,
          taxRate: 0.0,
          taxAmount: 0.0,
          excludingTaxAmount: 0.0,
          quantity: 1,
          billingAmount: 0.0,
          remarks: ''
        },
        splitChargeForm: {},
        btnSplitEnable: false,
        onlyChangeQuantity: true
      },
      autoSplitChargeDialog: {
        visible: false,
        maxAmount: 0.0,
        confirmSplitEnable: true,
        chargeOrigin: {
          chargeSource: 1,
          sequenceNumber: 1,
          uuid: '',
          chargeName: '',
          currency: '',
          amount: 0.0,
          excludingTaxAmount: 0.0,
          taxRate: 0.0,
          taxAmount: 0.0,
          quantity: 1,
          unitRate: 0.0,
          jobUuid: '',
          billingGroupUuid: ''
        },
        rowData: [],
        gridParams: {},
        columnDefs: [
          { headerName: this.$t('SeaExport.SequenceNumber'), field: 'sequenceNumber', colId: 'sequenceNumber', initialWidth: 80 },
          { headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount', colId: 'amount', initialWidth: 80,
            cellRenderer: (params) => ColumnUtils.realProfitFunc(params.value)
          },
          { headerName: this.$t('Invoice.invoice_taxExcludedPrice'), field: 'excludingTaxAmount', colId: 'excludingTaxAmount', initialWidth: 80,
            cellRenderer: (params) => ColumnUtils.realProfitFunc(params.value)
          },
          { headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount', colId: 'taxAmount', initialWidth: 80,
            cellRenderer: (params) => ColumnUtils.realProfitFunc(params.value)
          },
          { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', colId: 'taxRate', initialWidth: 80 }
        ],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        gridApi: null
      },
      hmToFinanceApi: false,
      // 合并自 Step2：合计折合重算 + 币种转换模式 + 校验规则弹窗
      reCalc: true, // 折合重算
      totalResultList: [], // [P1] 合计组件 @callback 回传的 CurrencyTotalItem[]，用于自定义合计文案
      currencyConversionInInvoices: false,
      batchCheckingWindow: {
        lob: SystemConstants.SE.code,
        visible: false,
        jobs: [],
        resData: {},
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      }
    }
  },
  computed: {
    // paramsFinal() {
    //   const defaultParams = {
    //     mode: 0,
    //     // 应收开票
    //     paymentType: 1,
    //     // 按费用
    //     makeInvoiceMethod: 1
    //   }
    //   return Object.assign(defaultParams, this.params)
    // },
    // 开票方式描述
    invoicingMethod() {
      if (this.properties.isAr) {
        return this.$t('Invoice.invoice_receivablesInvoicing')
      } else {
        return this.isCollectInvoice ? this.$t('Invoice.invoice_payablesCollectInvoice') : this.$t('Invoice.invoice_payablesInvoicing')
      }
    },
    // 发票类型
    InvoiceConstant() {
      return InvoiceConstant
    },
    // 发票类型下拉数据源：固定展示原有数据源（全电=电子普票+电子专票两个选项）。
    // 结算对象「税率-发票类型配置」只决定默认值，不收窄下拉选项：配置匹配成功、
    // 多条数据批量匹配、甚至匹配不上，下拉始终展示完整选项，避免被配置锁死为单一项
    invoiceTypeOptions() {
      return this.isFei ? InvoiceConstant.INVOICE_TYPES_FEI : InvoiceConstant.INVOICE_TYPES
    },
    // 基础数据
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    // 发票项目名称列表
    invoiceGoodsNameRowData() {
      let invoiceGoodsNameList = this.properties.invoiceGoodsNameList
      if (!invoiceGoodsNameList || invoiceGoodsNameList.length === 0) {
        invoiceGoodsNameList = []
      } else {
        invoiceGoodsNameList = invoiceGoodsNameList.filter(p => p.invoiceType === this.properties.invoiceType)
      }
      return invoiceGoodsNameList
    },
    // 是否收票，收票需要更改国际化【仅处理-按费用、按业务、按账单、按对账单】
    isCollectInvoice() {
      return !this.properties.isAr && (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2 || this.properties.makeInvoiceMethod === 3 || this.properties.makeInvoiceMethod === 4)
    },
    // 合并自 Step2：合计折合汇率精度
    txtRate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.properties.txtCurrency1)
    },
    txtRate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.properties.txtCurrency2)
    },
    // 合并自 Step2：unInvoiceCreate（收票必须填写发票号/抬头）
    unInvoiceCreate() {
      return this.properties.apInvoiceCreateMusthaveTitileAndNumber && this.isCollectInvoice
    },
    // 合并自 Step2：右下角合计 ar-field
    arField() {
      return 'receivable'
    },
    // 合并数据源：Step1 无 ag-grid 选择，所有 allEntities 隐式全部选中。
    // 与 Step2 refreshSelectedCountChargeGrid 的过滤一致：entity==='charge' || entity===undefined。
    invoiceCharges() {
      const list = Array.isArray(this.properties.allEntities) ? this.properties.allEntities : []
      return list.filter(item => item && (item['entity'] === 'charge' || item.entity === undefined))
    },
    // [P1] 合计自定义文案：把合计组件算出的 CurrencyTotalItem[] 折成单行展示
    //   多币种(有折合项)：{发票币种}:{折合总额}({原币1}:{额}，{原币2}:{额})
    //   单币种：{币种}:{额}
    totalDisplayText() {
      const fmt = (v) => {
        if (v == null || v === '') return ''
        if (typeof v === 'object' && typeof v.toFormat === 'function') return v.toFormat(2)
        return v
      }
      const list = Array.isArray(this.totalResultList) ? this.totalResultList : []
      const convertItem = list.find(it => it && it.textDecoration)
      const others = list.filter(it => it && !it.textDecoration)
      if (convertItem) {
        const main = (this.properties.currency || '') + ':' + fmt(convertItem.amount)
        const breakdown = others.map(it => (it.currency || '') + ':' + fmt(it.amount)).join('，')
        return breakdown ? main + '(' + breakdown + ')' : main
      }
      return others.map(it => (it.currency || '') + ':' + fmt(it.amount)).join('，')
    },
    // 发票项目名称设置显示列
    invoiceGoodsNameColumnDefs() {
      return [
        { headerName: this.$t('Invoice.invoice_invoiceType'), field: 'invoiceType', width: 160,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-select',
            options: this.isFei ? InvoiceConstant.INVOICE_TYPES_FEI : InvoiceConstant.INVOICE_TYPES,
            optionField: {
              labelFunc: item => {
                return this.$store.getters.language === 'zh' ? item.chineseName : item.englishName
              },
              value: 'code'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxRevenueShortName'), field: 'taxRevenueShortName', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxRevenueName'), field: 'taxRevenueName', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemCNY'), field: 'goodsNameRMB', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemUSD'), field: 'goodsNameUSD', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemJPY'), field: 'goodsNameJPY', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemEUR'), field: 'goodsNameEUR', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-select',
            options: this.isNuoNuo ? InvoiceConstant.INVOICE_GOODS_NAME_TAX_RATE : InvoiceConstant.INVOICE_GOODSNAME_TAX_RATE,
            optionField: {
              labelFunc: item => {
                return item.chineseName
              },
              value: 'code'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DefaultDetailItems'), field: 'defaultDetails', initialWidth: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: this.isEditing ? 'el-checkbox' : 'span',
            attrs: {
              isEditCBFunc: (params) => {
                return this.isEditing
              }, trueLabel: true, falseLabel: false, textConverter: (val) => {
                return val ? '√' : ''
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SetDefaultItemName'), field: 'defaultGoodsName', width: 140,
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (!newVal) {
        return
      }
      // 如果在账单(bill)、对账单(billGroup)或开票模块(invoice)中，且当前选择的是"按抬头开票"，则自动切换到"合并开票"
      if ((this.viewSource === 'bill' || this.viewSource === 'billGroup' || this.viewSource === 'invoice') && this.properties.typeGroup === 'title') {
        this.properties.typeGroup = 'multi'
      }
      this.resetInvoiceTypeByTaxRate()
      this.changeInvoiceType()
      // 打开弹窗兜底执行配置逻辑：watch allEntities 依赖数组引用变化，
      // 当第二次打开时引用未变（数据复用/加载提前返回）则 watch 不触发，配置既不执行也无日志；
      // 此处幂等调用（requestKey 相同则短路重放默认值，不重复请求），与 allEntities watch 双保险
      this.applyCompanyTaxInvoiceConfig()
    },
    'properties.allEntities': function() {
      // allEntities 是需要加载一段时间的，不能写在visible事件里
      this.resetInvoiceTypeByTaxRate()
      this.rateTipHC()
      // 按结算对象加载「税率-发票类型配置」，重建发票类型下拉数据源并设置默认值
      this.applyCompanyTaxInvoiceConfig()
      // 单步流程：数据加载后即计算折合汇率（rateCache / otherCurrencys / showCurrency），
      // 使底部「汇率」栏在展示阶段就可见（仅多币种，即费用币种≠发票币种时才有折合）
      this.checkState()
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
    if (this.visible) {
      this.innerVisible = true
    }
    this.fetchData()
    this.loadMergedConfig()
  },
  methods: {
    fetchData() {},
    // [P1] 接收合计组件 @callback 回传的 resultList(CurrencyTotalItem[])，供 totalDisplayText 拼接
    onTotalCallback(list) {
      this.totalResultList = Array.isArray(list) ? list : []
    },
    // 合并自 Step2：加载校验规则门禁 + 币种转换模式所需的缓存配置
    async loadMergedConfig() {
      try {
        await cache.load(cacheName.CONFIG)
        this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM'
        this.currencyConversionInInvoices = Number(cache.config.get('CurrencyConversionInInvoices')) === 1
      } catch (e) {
        console.warn('loadMergedConfig failed', e)
      }
    },
    // 判断是否显示"按抬头开票"选项
    shouldShowTitleOption() {
      // 只在 reconciliation(对账页签) 和 invoiceQuery(发票查询) 中显示
      return this.viewSource === 'reconciliation' || this.viewSource === 'invoiceQuery'
    },
    async toNext() {
      if (this.properties.toExoSystemHC && this.properties.allEntities && this.properties.isAr) {
        const taxRates = new Set()
        for (const data of this.properties.allEntities) {
          if (data.entity === 'charge' || [1, 2].includes(this.properties.makeInvoiceMethod)) {
            taxRates.add(data.taxRate)
          }
        }
        if (taxRates.size > 1) {
          this.$confirm(this.$t('CargoMsg.Cargo_CurrentInvoiceDifferentRates'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.doNext()
          })
        } else {
          this.doNext()
        }
      } else {
        this.doNext()
      }
    },
    async doNext() {
      // groupingCurrencyType: currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
      if (this.properties.currencyGroup === 1) {
        this.properties.groupingCurrencyType = 0
      } else {
        if (this.properties.cbAssignCurrency) {
          this.properties.groupingCurrencyType = 1
        } else {
          this.properties.groupingCurrencyType = 2
        }
      }
      // isGenCostInvoice: 生成成本发票开关已移除，固定为 false
      this.properties.isGenCostInvoice = false
      //
      this.properties.invoiceGoodsName = this.getInvoiceGoodsName()
      // 重置
      if (this.properties.isHedge) {
        this.properties.receivedRadio = 'ALL'
        this.properties.paymentRadio = 'ALL'
      }
      console.log('this.properties: stepOne', this.properties)
      //
      // 注意：此处不再调用 checkState()。checkState 会清空 rateCache 并向后端重新拉取汇率，
      // 会覆盖用户在底部「汇率」栏手动修改的折合汇率（例如把手动输入的 1 冲回系统汇率 6.8）。
      // 折合金额/父级汇总已由 txtRate1Change/txtRate2Change 实时更新；此处仅需刷新合计展示即可。
      // 需要重算汇率的场景（初次加载、改发票币种、费用拆分）均已在各自入口单独调用 checkState。
      this.reSetChargeCurrencyTotalGroup()
      await this.generate()
    },
    // 发票项目名称
    getInvoiceGoodsName() {
      if (this.properties.invoiceGoodsNameList.length === 0) return {}
      const rowDataSelected = getGridSelected(this.invoiceGoodsName.gridOptions)
      const selectedItem = rowDataSelected.length > 0 ? rowDataSelected[0] : null
      console.log('getInvoiceGoodsName', selectedItem)
      // CARGO-8602，当左侧发票类型与右侧选中的发票类型不一致时
      if (selectedItem === null || selectedItem.invoiceType !== this.properties.invoiceType) {
        // CARGO-37694 14552-招通供应链 发票费用项目名称，无法覆盖多币种合并开票代出费用项目名称
        // for (const item of this.properties.invoiceGoodsNameList) {
        //   if (item.defaultGoodsName && !StrUtils.isEmpty(item.uuid) && item.invoiceType === this.properties.invoiceType) {
        //     return item
        //   }
        // }
        // return {}
        let rightItem = null
        const itemArr = []
        const isRmb = this.properties.currency === 'RMB'
        const isUsd = this.properties.currency === 'USD'
        const isJpy = this.properties.currency === 'JPY'
        for (const item of this.properties.invoiceGoodsNameList) {
          if (!StrUtils.isEmpty(item.uuid) && item.invoiceType === this.properties.invoiceType) {
            if ((isRmb && item.goodsNameRMB) || (isUsd && item.goodsNameUSD) || (isJpy && item.goodsNameJPY)) {
              if (item.defaultGoodsName) {
                rightItem = item
                break
              }
              itemArr.push(item)
            }
          }
        }
        // 未取到默认的，则随机取一个满足条件的
        if (!rightItem && itemArr.length > 0) {
          rightItem = itemArr[0]
        }
        return rightItem || {}
      } else {
        return selectedItem
      }
    },
    // InvoiceChargePage.checkState
    async checkState() {
      this.properties.otherCurrencys = []
      this.properties.otherRates = []
      this.properties.rateCache = {}
      console.log('checkState:', this.properties.allEntities)
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单、5=付款申请单
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      // 记录每笔账单/对账单/付款申请单的开票总金额(开票方式为账单/对账单/付款申请单，向上汇总开票金额)
      const invoiceAmountMap = new Map()
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const charge of this.properties.allEntities) {
          if (charge.currency !== this.properties.currency) {
            if (!this.properties.rateCache[charge.currency]) {
              this.properties.rateCache[charge.currency] =
                await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, new Date(), 0)
            }
            charge.invoiceRate = this.properties.rateCache[charge.currency]
            charge.invoiceAmount2 = NumberUtils.roundHalfUp(
              RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
          } else {
            charge.invoiceRate = 1
            charge.invoiceAmount2 = charge.amount
          }
          if (charge['entity'] === 'charge') {
            let uuid = '' // 列表父节点的UUID
            if (makeInvoiceMethod === 3) {
              uuid = charge['billingUuid']
            } else if (makeInvoiceMethod === 4) {
              uuid = charge['billingGroupUuid']
            } else if (makeInvoiceMethod === 5) {
              uuid = charge['billingPaymentUuid']
            }
            if (invoiceAmountMap.has(uuid)) {
              // invoiceAmountMap.set(uuid, invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
              invoiceAmountMap.set(uuid, RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2, this.properties.currency))
            } else {
              invoiceAmountMap.set(uuid, (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
            }
          }
          if (charge.currency !== this.properties.currency && this.properties.otherCurrencys.indexOf(charge.currency) === -1) {
            this.properties.otherCurrencys.push(charge.currency)
          }
        }
      }
      if (makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) { // 处理父级显示列中的特殊字段
        for (const item of this.properties.allEntities) {
          // 树状图父节点某些字段没有值则显示为空
          if (item['entity'] !== 'charge' && item.entity !== undefined) {
            item['amount'] = ''
            item['excludingTaxAmount'] = ''
            item['invoiceRate'] = ''
            item['invoiceAmount2'] = ''
          }

          let uuid = ''
          if (item['entity'] === 'billing' && makeInvoiceMethod === 3) {
            uuid = item['billingUuid']
          } else if (item['entity'] === 'billingGroup' && makeInvoiceMethod === 4) {
            uuid = item['billingGroupUuid']
          } else if (item['entity'] === 'billPayment' && makeInvoiceMethod === 5) {
            uuid = item['billingPaymentUuid']
          }
          if (invoiceAmountMap.has(uuid)) {
            // item['invoiceAmount2'] = NumberUtils.roundHalfUp(invoiceAmountMap.get(uuid), 2)
            item['invoiceAmount2'] = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid), this.properties.currency), 2)
          }
        }
      }
      this.showCurrency()
    },
    showCurrency() {
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      console.log('showCurrency:', this.properties.otherCurrencys)
      //
      if (this.properties.otherCurrencys.length > 0) {
        this.properties.txtCurrency1 = this.properties.otherCurrencys[0]
        this.properties.txtRate1 = this.changeInfinity(this.properties.rateCache[this.properties.txtCurrency1])
      }
      if (this.properties.otherCurrencys.length > 1) {
        this.properties.txtCurrency2 = this.properties.otherCurrencys[1]
        this.properties.txtRate2 = this.changeInfinity(this.properties.rateCache[this.properties.txtCurrency2])
      }
    },
    changeInfinity(value) {
      if (value === Infinity) {
        return ''
      }
      return NumberUtils.formatNumber(value, 8)
    },
    toAdd() {
      // // this.maintainDialog.maintainForm =
      // this.maintainDialog.title = '新增'
      // this.maintainDialog.isEdit = false
      // this.maintainDialog.show = true
      this.isEditing = true
      this.needSave = true
      this.isEditInvoiceGoodsName()
      const row = {}
      // 发票类型
      row.invoiceType = this.properties.invoiceType
      row.goodsNameRMB = ''
      row.goodsNameUSD = ''
      row.goodsNameJPY = ''
      row.goodsNameEUR = ''
      row.taxRate = 0
      row.taxRevenueShortName = ''
      row.taxRevenueName = ''
      // 分公司
      row.officeId = this.$store.getters.currentOfficeId
      this.properties.invoiceGoodsNameList.push(row)
      console.log('toAdd', row)
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
      })
    },
    toEdit() {
      // const self = this
      // getGridSelectedIds(this.gridOptions).then(ids => {
      //   if (ids.length === 0) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // this.maintainDialog.maintainForm = { ...getGridSelected(this.gridOptions)[0] }
      //     this.maintainDialog.title = '修改'
      //     this.maintainDialog.isEdit = true
      //     this.maintainDialog.show = true
      //   }
      // })
      this.isEditing = true
      this.needSave = true
      this.isEditInvoiceGoodsName()
    },
    isEditInvoiceGoodsName() {
      console.log('isEditInvoiceGoodsName', this.isEditing)
      for (const item of this.invoiceGoodsNameColumnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = this.isEditing
        }
      }
      // 刷新
      this.properties.invoiceGoodsNameList = [...this.properties.invoiceGoodsNameList]
    },
    toDelete() {
      // const self = this
      // getGridSelectedIds(this.invoiceGoodsName.gridOptions).then(ids => {
      //   if (ids.length === 0) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // eslint-disable-next-line no-unused-vars
      //     const rowDataSelected = { ...getGridSelected(this.gridOptions)[0] }
      //     // todo: do delete and close this dialog finally
      //   }
      // })
      const rowDataSelected = getGridSelected(this.invoiceGoodsName.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      //
      const self = this
      self.$confirm(this.$t('CargoMsg.Cargo_ConfirmCancellationOfRecord'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        self.loading = getLoading()
        deleteInvoiceGoodsName(rowDataSelected).then(res => {
          console.log('deleteInvoiceGoodsName', res)
          self.properties.invoiceGoodsNameList = res.data
          //
          this.isEditing = false
          this.needSave = false
          this.isEditInvoiceGoodsName()
        }).finally(() => {
          self.loading.close()
        })
      }).catch(() => {
        //
      })
    },
    // 保存
    toSave() {
      if (this.properties.invoiceGoodsNameList.length > 0) {
        const invoiceGoodsNameList = this.properties.invoiceGoodsNameList
        // 重复维护
        for (const item of invoiceGoodsNameList) {
          if (item.invoiceType === '') {
            this.$message.warning(this.$t('CargoMsg.Cargo_RecordsWithEmptyInvoiceTypeExist'))
            return
          }
          // CARGO-8599，RMB/USD费用项目名称不可以为空
          // StrUtils.isEmpty(item.goodsNameJPY) 日币先不加为空判断，历史数据基本都是空的
          if (StrUtils.isEmpty(item.goodsNameRMB) || StrUtils.isEmpty(item.goodsNameUSD)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_IINMCTBE'))
            return
          }

          let bExist = false
          for (const item2 of invoiceGoodsNameList) {
            if (item.uuid !== item2.uuid && item.invoiceType === item2.invoiceType && item.goodsNameRMB === item2.goodsNameRMB && item.goodsNameUSD === item2.goodsNameUSD && item.goodsNameJPY === item2.goodsNameJPY && item.goodsNameEUR === item2.goodsNameEUR) {
              bExist = true
              break
            }
            // 都是新增的
            if (item.invoiceType === item2.invoiceType && StrUtils.isEmpty(item.uuid) && StrUtils.isEmpty(item2.uuid) && item !== item2 && item.goodsNameRMB === item2.goodsNameRMB && item.goodsNameUSD === item2.goodsNameUSD && item.goodsNameJPY === item2.goodsNameJPY && item.goodsNameEUR === item2.goodsNameEUR) {
              bExist = true
              break
            }
          }
          if (bExist) {
            const stateName = ColumnUtils.invoiceTypeFunc(item.invoiceType)
            this.$message.warning(this.$t('CargoMsg.Cargo_DMROITE').format(stateName))
            return
          }
        }

        this.loading = getLoading()
        saveInvoiceGoodsName(this.properties.invoiceGoodsNameList).then(res => {
          console.log('saveInvoiceGoodsName', res)
          this.properties.invoiceGoodsNameList = res.data
          //
          this.isEditing = false
          this.needSave = false
          this.isEditInvoiceGoodsName()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 设置默认
    doDefaultSetting() {
      if (this.properties.invoiceGoodsNameList.length === 0) return
      const rowDataSelected = getGridSelected(this.invoiceGoodsName.gridOptions)
      if (rowDataSelected.length === 0) return
      const invoiceGoodsName = rowDataSelected[0]
      invoiceGoodsName.defaultGoodsName = true
      console.log('doDefaultSetting', invoiceGoodsName)
      // 相同发票类型
      for (const item of this.properties.invoiceGoodsNameList) {
        if (item.invoiceType === invoiceGoodsName.invoiceType && item.uuid !== invoiceGoodsName.uuid) {
          item.defaultGoodsName = false
        }
      }
      // 保存
      this.toSave()
    },
    onCellChange(params) {
      console.log('onCellChange', params)
      const invoiceGoodsName = params.data
      const field = params.field
      const value = params.value
      //
      const invoiceGoodsNameList = this.properties.invoiceGoodsNameList
      const invoiceItemGoodsName = this.properties.invoiceItemGoodsName
      const defaultGoodsName = this.properties.defaultGoodsName
      switch (field) {
        case 'invoiceType': {
          invoiceGoodsName.invoiceType = value
          // 默认值
          let bExist = false
          for (const item of invoiceGoodsNameList) {
            if (item.invoiceType === invoiceGoodsName.invoiceType && item.uuid !== invoiceGoodsName.uuid) {
              bExist = true
              break
            }
            // 都是新增的
            if (item.invoiceType === invoiceGoodsName.invoiceType && StrUtils.isEmpty(invoiceGoodsName.uuid) && StrUtils.isEmpty(item.uuid) && item !== invoiceGoodsName) {
              bExist = true
              break
            }
          }
          if (!bExist) {
            invoiceGoodsName.defaultGoodsName = true
            // 0:海运费 1:根据币种计算 2:发票项目根据发票类型转换(增值税普通发票则名称为：国际货代服务费；增值税专用发票则名称为：货运代理费)
            if (invoiceItemGoodsName === 0) {
              invoiceGoodsName.goodsNameRMB = defaultGoodsName
              invoiceGoodsName.goodsNameUSD = defaultGoodsName
              invoiceGoodsName.goodsNameJPY = defaultGoodsName
              invoiceGoodsName.goodsNameEUR = defaultGoodsName
            } else if (invoiceItemGoodsName === 1) {
              invoiceGoodsName.goodsNameRMB = this.$t('Clearing.InternationalFreightForwardingFee')
              invoiceGoodsName.goodsNameUSD = this.$t('Clearing.InternationalShippingFee')
              invoiceGoodsName.goodsNameJPY = this.$t('Clearing.InternationalShippingFee')
              invoiceGoodsName.goodsNameEUR = this.$t('Clearing.InternationalShippingFee')
            } else if (invoiceItemGoodsName === 2) {
              if (invoiceGoodsName.invoiceType === 2) {
                invoiceGoodsName.goodsNameRMB = this.$t('Clearing.InternationalFreightServiceFee')
                invoiceGoodsName.goodsNameUSD = this.$t('Clearing.InternationalFreightServiceFee')
                invoiceGoodsName.goodsNameJPY = this.$t('Clearing.InternationalFreightServiceFee')
                invoiceGoodsName.goodsNameEUR = this.$t('Clearing.InternationalFreightServiceFee')
              } else if (invoiceGoodsName.invoiceType === 3) {
                invoiceGoodsName.goodsNameRMB = this.$t('Clearing.FreightForwardingFee')
                invoiceGoodsName.goodsNameUSD = this.$t('Clearing.FreightForwardingFee')
                invoiceGoodsName.goodsNameJPY = this.$t('Clearing.FreightForwardingFee')
                invoiceGoodsName.goodsNameEUR = this.$t('Clearing.FreightForwardingFee')
              } else {
                invoiceGoodsName.goodsNameRMB = defaultGoodsName
                invoiceGoodsName.goodsNameUSD = defaultGoodsName
                invoiceGoodsName.goodsNameJPY = defaultGoodsName
                invoiceGoodsName.goodsNameEUR = defaultGoodsName
              }
            } else {
              invoiceGoodsName.defaultGoodsName = false
            }
          }
          // 如果有默认 其他也有默认
          if (invoiceGoodsName.defaultDetails) {
            this.defaultDetail(invoiceGoodsNameList, invoiceGoodsName)
          }
          break
        }
        case 'taxRevenueShortName':
          invoiceGoodsName.taxRevenueShortName = value
          break
        case 'taxRevenueName':
          invoiceGoodsName.taxRevenueName = value
          break
        case 'taxRate':
          // 如果有默认 其他也有默认
          if (invoiceGoodsName.defaultDetails) {
            this.defaultDetail(invoiceGoodsNameList, invoiceGoodsName)
          }
          break
        case 'defaultDetails':
          if (params.value) {
            this.defaultDetail(invoiceGoodsNameList, invoiceGoodsName)
          }
          break
        case '':
          break
        default:
      }
      // 刷新
      this.gridApi.refreshCells({ force: true })
      this.$emit('cellChange', params)
    },
    defaultDetail(invoiceGoodsNameList, invoiceGoodsName) {
      for (const item of invoiceGoodsNameList) {
        if (item.invoiceType === invoiceGoodsName.invoiceType && item.taxRate === invoiceGoodsName.taxRate && item.uuid !== invoiceGoodsName.uuid) {
          item.defaultDetails = false
        }
        // 都是新增的
        if (item.invoiceType === invoiceGoodsName.invoiceType && item.taxRate === invoiceGoodsName.taxRate && StrUtils.isEmpty(invoiceGoodsName.uuid) && StrUtils.isEmpty(item.uuid) && item !== invoiceGoodsName) {
          item.defaultDetails = false
        }
      }
    },
    doSave() {},
    lastFinsh() {
      this.makeInvoiceStepTwoDialog.visible = false
      this.$emit('lastFinsh')
    },
    cancel() {
      this.$emit('toStepHandler', '')
    },
    // 选择开票币种
    async currencyChangeEvent(value) {
      console.log('currencyChangeEvent:', value)
      this.properties.currency = value.code
      // 单步流程：合计在 Step1 即时显示，改开票币种后需立即按新币种重算折合并刷新合计
      // （老两步流程里这一步由进 Step2 时的 checkState 完成）
      await this.checkState()
      this.reSetChargeCurrencyTotalGroup()
    },
    // 选择发票类型
    invoiceTypeChange(value) {
      // 非增值税发票，默认选择纸质发票
      if (!(value === 2 || value === 3)) {
        this.properties.groupingMakeType = 0
      }
      // 电子发票（增值税专用发票） /  电子发票（普通发票） 默认电子发票
      if (value === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || value === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
        if (!this.properties.specificConstraintType) {
          this.properties.specificConstraintType = '00'
        }
        this.properties.groupingMakeType = 1
      } else {
        this.properties.specificConstraintType = ''
      }
    },
    // 选择结算部门
    settleDepartmentChangeEvent(value) {
      console.log('settleDepartmentChangeEvent:', value)
      if (StrUtils.isEmpty(value.value)) {
        this.properties.settleDepartment = 0
        this.properties.settleDepartmentPrefix = ''
      } else {
        this.properties.settleDepartment = value.value
        this.properties.settleDepartmentPrefix = value.jobNoPrefix
      }
    },
    // ============ 结算对象「税率-发票类型配置」兜底（对账/账单/对账单/开票-收票页签） ============
    // 是否启用配置兜底：对账(reconciliation)/账单(bill)/对账单(billGroup)页签 及 对账单详情(billGroupDetail)、开票菜单-开票/收票页签(tabMakeInvoice/invoice)
    isTaxInvoiceConfigEnabled() {
      return ['reconciliation', 'bill', 'billGroup', 'billGroupDetail', 'tabMakeInvoice', 'invoice'].includes(this.viewSource)
    },
    // 从所选数据实体收集结算对象 companyUuid（去重）
    // 费用/业务开票(1/2)实体自带 accountUuid；账单/对账单树(3/4)仅返回 accountId，经基础数据缓存反查
    async collectCompanyUuids() {
      const allEntities = Array.isArray(this.properties.allEntities) ? this.properties.allEntities : []
      const uuidSet = new Set()
      const accountIds = []
      allEntities.forEach(entity => {
        if (!entity) return
        if (!StrUtils.isEmpty(entity.accountUuid)) {
          uuidSet.add(entity.accountUuid)
        } else if (entity.accountId && !accountIds.includes(Number(entity.accountId))) {
          accountIds.push(Number(entity.accountId))
        }
      })
      if (accountIds.length > 0) {
        if (!getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', accountIds[0])) {
          try {
            await syncSpecificBasicData(basicCacheKeys.basic_data_Company)
          } catch (e) {
            // 缓存加载失败不中断：结算对象反查不到时按无配置回落原有逻辑
          }
        }
        accountIds.forEach(accountId => {
          const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', accountId)
          if (company && !StrUtils.isEmpty(company.uuid)) {
            uuidSet.add(company.uuid)
          }
        })
      }
      return Array.from(uuidSet)
    },
    // 收集所选数据实体下的费用税率（去重，兼容账单/对账单树节点递归），用于单选场景与结算单位配置的精确匹配
    collectEntityTaxRates() {
      const allEntities = Array.isArray(this.properties.allEntities) ? this.properties.allEntities : []
      const rates = new Set()
      const collect = (node) => {
        if (!node) return
        const rawTaxRate = node.taxRate !== undefined && node.taxRate !== null && node.taxRate !== ''
          ? node.taxRate
          : node.chargeTaxRate
        if (rawTaxRate !== undefined && rawTaxRate !== null && rawTaxRate !== '') {
          // 兼容 '6%'/'6.00' 等存储格式，与 resetInvoiceTypeByTaxRate 保持同一清洗规则
          const rateValue = Number(String(rawTaxRate).replace('%', '').replace(/[^\d.-]/g, '').trim())
          if (!Number.isNaN(rateValue)) {
            rates.add(rateValue)
          }
        }
        const children = node.children || node.chargeList || []
        if (Array.isArray(children)) {
          children.forEach(collect)
        }
      }
      allEntities.forEach(collect)
      return Array.from(rates)
    },
    // 清除已加载的配置状态：结算对象集合变化、无配置或不适用场景时，发票类型下拉回落原有数据源
    // 弹窗组件跨开合持久存在（无 v-if），不清除会残留上一批数据的配置下拉数据源
    resetTaxInvoiceConfigState() {
      this.taxInvoiceConfigOptions = []
      this.taxInvoiceConfigCombos = []
      this.taxInvoiceConfigByCompany = {}
      this.taxInvoiceConfigLoaded = false
      this.taxInvoiceConfigRequestKey = ''
      this.taxInvoiceConfigBatchApplied = false
      this.taxInvoiceConfigDefaultType = null
    },
    // 按结算对象拉取「税率-发票类型配置」，(taxRate, invoiceType) 组合去重后重建发票类型下拉数据源并设置默认值
    async applyCompanyTaxInvoiceConfig() {
      try {
        if (!this.isTaxInvoiceConfigEnabled()) {
          // 不适用配置兜底的场景：清除上一批数据遗留的配置状态
          this.resetTaxInvoiceConfigState()
          return
        }
        const companyUuids = await this.collectCompanyUuids()
        if (companyUuids.length === 0) {
          this.resetTaxInvoiceConfigState()
          return
        }
        // 匹配结果取决于 (费用税率, 结算对象) 配对：requestKey 需附加配对信息（单选/批量均需要），
        // 否则同结算对象集合换不同税率数据、或税率相同但归属结算对象不同时会错误复用上一批的匹配结果与默认值
        const entityPairs = this.collectEntityTaxRateCompanyPairs()
        let requestKey = companyUuids.slice().sort().join(',')
        if (entityPairs.length > 0) {
          requestKey += '|' + entityPairs.map(pair => pair.companyUuid + '_' + pair.taxRate).sort().join(',')
        }
        if (requestKey === this.taxInvoiceConfigRequestKey) {
          // 同一批数据（结算对象+税率配对一致）不重复请求：已加载到配置则仅重设默认值，确无配置则维持原有数据源
          if (this.taxInvoiceConfigLoaded) {
            this.applyDefaultInvoiceTypeByConfig()
          }
          return
        }
        // 结算对象集合变化：先清除上一批配置状态，请求期间与无配置时均回落原有数据源
        this.resetTaxInvoiceConfigState()
        let allSuccess = true
        const resultList = await Promise.all(companyUuids.map(companyUuid =>
          loadCompanyRelated({ companyUuid: companyUuid, taxInvoiceList: true }).then(res => {
            const data = res && res.data ? res.data : {}
            return Array.isArray(data.taxInvoiceList) ? data.taxInvoiceList : []
          }).catch(() => {
            // 请求失败按无配置处理：本次回落原有逻辑，且不记录缓存标识（下次重试）
            allSuccess = false
            return []
          })
        ))
        // 按结算对象分组归一配置（注意：配置表 taxRate/invoiceType 均为字符串数字 '0'/'6'/'9'、'6'/'7'，
        // 统一归一：taxRate → String，invoiceType → Number（对应发票类型常量 CommonState.code），后续比较均在同类型间进行）
        const byCompany = {}
        companyUuids.forEach((companyUuid, index) => {
          const comboMap = {}
          const taxInvoiceList = resultList[index] || []
          taxInvoiceList.forEach(item => {
            if (!item || StrUtils.isEmpty(item.invoiceType)) return
            const taxRate = StrUtils.isEmpty(item.taxRate) ? '' : String(item.taxRate)
            const invoiceType = Number(item.invoiceType)
            if (Number.isNaN(invoiceType)) return
            comboMap[taxRate + '_' + invoiceType] = { taxRate: taxRate, invoiceType: invoiceType }
          })
          byCompany[companyUuid] = Object.values(comboMap)
        })
        this.taxInvoiceConfigByCompany = byCompany
        // 汇总去重（单选场景沿用合并匹配）
        const comboMapAll = {}
        Object.values(byCompany).forEach(list => {
          list.forEach(combo => {
            comboMapAll[combo.taxRate + '_' + combo.invoiceType] = combo
          })
        })
        const combos = Object.values(comboMapAll)
        if (combos.length === 0) {
          // 全部请求成功且确无配置时记录该集合标识，同一批数据再次打开不重复请求；有失败请求则下次重试
          if (allSuccess) {
            this.taxInvoiceConfigRequestKey = requestKey
          }
          return
        }
        // 单选场景：提取该数据费用项税率，与结算单位配置精确匹配；匹配成功用配置发票类型重建下拉并设默认值，失败维持原有业务逻辑
        if (this.properties.isSingleSelect === true) {
          const entityTaxRates = this.collectEntityTaxRates()
          let matched = []
          if (entityTaxRates.length === 1) {
            // 配置 taxRate 为字符串数字（'0'/'6'/'9'），实体税率为数值，双侧统一 Number 后比较
            matched = combos.filter(combo => Number(combo.taxRate) === Number(entityTaxRates[0]))
          }
          // 配置集合仅用于推导默认值；下拉固定展示原有数据源，不因配置收窄（匹配不上也展示完整选项）
          const singleCompanyUuid = entityPairs.length > 0 && entityPairs[0].companyUuid ? entityPairs[0].companyUuid : ''
          const companyCombos = singleCompanyUuid && Array.isArray(this.taxInvoiceConfigByCompany[singleCompanyUuid]) && this.taxInvoiceConfigByCompany[singleCompanyUuid].length > 0
            ? this.taxInvoiceConfigByCompany[singleCompanyUuid]
            : combos
          const optionMap = {}
          companyCombos.forEach(combo => {
            const constant = InvoiceConstant.INVOICE_TYPES_FEI.find(type => type.code === combo.invoiceType)
            if (constant) {
              optionMap[constant.code] = constant
            }
          })
          const options = Object.values(optionMap)
          if (matched.length > 0 && options.length > 0) {
            this.taxInvoiceConfigCombos = matched
            this.taxInvoiceConfigOptions = options
            this.taxInvoiceConfigRequestKey = requestKey
            this.taxInvoiceConfigLoaded = true
            this.taxInvoiceConfigBatchApplied = false
            // 数据源与默认值同帧生效：options 渲染后再设置 invoiceType，保证 v-model 与 option 严格相等（Number）
            this.$nextTick(() => {
              this.applyDefaultInvoiceTypeByConfig()
            })
            return
          }
          // 未匹配到税率对应的配置：显式清除配置下拉数据源，确保 invoiceTypeOptions 回落原有数据源、默认值走原有逻辑（如 0 税→普票）
          this.resetTaxInvoiceConfigState()
          if (allSuccess) {
            this.taxInvoiceConfigRequestKey = requestKey
          }
          // 唯一税率确无配置：回落原有业务逻辑；税率不唯一（如勾选 1 条对账单/业务，其下费用含多种税率）则落入下方批量规则处理
          if (entityTaxRates.length === 1) {
            return
          }
        }
        // 批量场景（含单选一条数据下多税率费用）：每条数据费用税率与其结算对象配置精确匹配，
        // 匹配成功时下拉显示匹配结果中的全部发票类型（普票/专票等，去重），默认值取税率最大值（9% 除外）对应的类型；
        // 不同结算对象对同一税率配置了不同发票类型且勾选数据税率命中时，弹确认框由用户决定是否统一开票
        {
          const result = await this.resolveBatchInvoiceTypeByConfig(entityPairs)
          if (result && Array.isArray(result.options) && result.options.length > 0) {
            this.taxInvoiceConfigCombos = result.matched
            this.taxInvoiceConfigOptions = result.options
            this.taxInvoiceConfigRequestKey = requestKey
            this.taxInvoiceConfigLoaded = true
            this.taxInvoiceConfigBatchApplied = true
            this.taxInvoiceConfigDefaultType = result.defaultType
            // 数据源与默认值同帧生效：options 渲染后再设置 invoiceType，保证 v-model 与 option 严格相等（Number）
            this.$nextTick(() => {
              this.applyDefaultInvoiceTypeByConfig()
            })
          } else {
            // 无匹配 / 匹配组合仅含 9% / 用户取消统一开票：回落原有业务逻辑
            // 记录集合标识避免重开同批数据时重复弹确认框；有失败请求则下次重试
            this.resetTaxInvoiceConfigState()
            if (allSuccess) {
              this.taxInvoiceConfigRequestKey = requestKey
            }
          }
        }
      } catch (e) {
        // 异常隔离：配置兜底任何异常均不中断原有开票流程
      }
    },
    // 收集所选数据实体的 (费用税率, 结算对象 companyUuid) 配对（去重，兼容账单/对账单树节点递归）
    // 费用/业务开票(1/2)实体自带 accountUuid；账单/对账单树(3/4)仅返回 accountId，经基础数据缓存反查
    // 注意：需在 collectCompanyUuids 之后调用（合作伙伴缓存已同步），accountId 反查才可用
    collectEntityTaxRateCompanyPairs() {
      const allEntities = Array.isArray(this.properties.allEntities) ? this.properties.allEntities : []
      const pairKeySet = new Set()
      const pairs = []
      const addPair = (rateValue, companyUuid) => {
        if (Number.isNaN(rateValue) || StrUtils.isEmpty(companyUuid)) return
        const key = companyUuid + '_' + rateValue
        if (pairKeySet.has(key)) return
        pairKeySet.add(key)
        pairs.push({ taxRate: rateValue, companyUuid: companyUuid })
      }
      const collect = (node, companyUuid) => {
        if (!node) return
        const rawTaxRate = node.taxRate !== undefined && node.taxRate !== null && node.taxRate !== ''
          ? node.taxRate
          : node.chargeTaxRate
        if (rawTaxRate !== undefined && rawTaxRate !== null && rawTaxRate !== '') {
          // 兼容 '6%'/'6.00' 等存储格式，与 collectEntityTaxRates 保持同一清洗规则
          const rateValue = Number(String(rawTaxRate).replace('%', '').replace(/[^\d.-]/g, '').trim())
          addPair(rateValue, companyUuid)
        }
        const children = node.children || node.chargeList || []
        if (Array.isArray(children)) {
          children.forEach(child => collect(child, companyUuid))
        }
      }
      allEntities.forEach(entity => {
        if (!entity) return
        let companyUuid = ''
        if (!StrUtils.isEmpty(entity.accountUuid)) {
          companyUuid = entity.accountUuid
        } else if (entity.accountId) {
          const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(entity.accountId))
          if (company && !StrUtils.isEmpty(company.uuid)) {
            companyUuid = company.uuid
          }
        }
        collect(entity, companyUuid)
      })
      return pairs
    },
    // 批量场景：每条数据费用税率与其结算对象配置精确匹配。
    // 1) 匹配成功且无类型分歧：下拉仅显示匹配组合中税率最大值（9% 除外）的发票类型，并作为默认值
    // 2) 同一税率对应多种发票类型（跨结算对象或配置矛盾）且勾选数据税率命中：弹确认框，由用户决定是否按随机选取的类型统一开票
    // 3) 无匹配 / 匹配组合仅含 9%（9% 混合校验由 rateTipHC 独立处理）/ 用户取消：返回 null，回落原有业务逻辑
    // 返回 Promise<{ options, matched } | null>
    resolveBatchInvoiceTypeByConfig(entityPairs) {
      const matched = []
      entityPairs.forEach(pair => {
        const companyCombos = this.taxInvoiceConfigByCompany[pair.companyUuid] || []
        companyCombos.forEach(combo => {
          if (Number(combo.taxRate) === Number(pair.taxRate)) {
            matched.push({ taxRate: Number(pair.taxRate), invoiceType: combo.invoiceType, companyUuid: pair.companyUuid })
          }
        })
      })
      if (matched.length === 0) {
        return Promise.resolve(null)
      }
      // 冲突检测：同一税率对应多个不同发票类型
      const rateTypeMap = {}
      matched.forEach(item => {
        if (!rateTypeMap[item.taxRate]) rateTypeMap[item.taxRate] = new Set()
        rateTypeMap[item.taxRate].add(item.invoiceType)
      })
      const hasConflict = Object.keys(rateTypeMap).some(rate => rateTypeMap[rate].size > 1)
      if (hasConflict) {
        // 冲突：从冲突税率对应的类型集合中随机选取一种，由用户确认是否统一开票
        const conflictTypes = new Set()
        Object.keys(rateTypeMap).forEach(rate => {
          if (rateTypeMap[rate].size > 1) {
            rateTypeMap[rate].forEach(type => conflictTypes.add(type))
          }
        })
        const typeList = Array.from(conflictTypes)
        const picked = typeList[Math.floor(Math.random() * typeList.length)]
        const constant = InvoiceConstant.INVOICE_TYPES_FEI.find(type => type.code === picked)
        const pickedName = constant ? (this.$store.getters.language === 'zh' ? constant.chineseName : constant.englishName) : picked
        return this.$confirm(
          '当前勾选中的数据，因配置的默认发票类型不一致，请确认是否按照\'' + pickedName + '\'发票类型统一开票',
          this.$t('CargoMsg.Cargo_Tips'),
          {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }
        ).then(() => {
          // 统一开票：下拉仅确认的类型，默认值同
          return constant ? { options: [constant], matched: matched, defaultType: constant.code } : null
        }).catch(() => {
          // 用户取消统一开票：回落原有业务逻辑
          return null
        })
      }
      // 无冲突：下拉显示匹配结果中的全部发票类型（普票/专票等，去重），默认值取税率最大值（9% 除外）对应的类型
      const nonNine = matched.filter(item => Number(item.taxRate) !== 9)
      if (nonNine.length === 0) {
        // 仅含 9%：保留原有逻辑默认值（9% 提示由 rateTipHC 处理）
        return Promise.resolve(null)
      }
      const maxRateItem = nonNine.reduce((max, item) => (Number(item.taxRate) > Number(max.taxRate) ? item : max))
      const optionMap = {}
      matched.forEach(item => {
        const constant = InvoiceConstant.INVOICE_TYPES_FEI.find(type => type.code === item.invoiceType)
        if (constant) {
          optionMap[constant.code] = constant
        }
      })
      const options = Object.values(optionMap)
      const defaultConstant = optionMap[maxRateItem.invoiceType]
      if (options.length === 0 || !defaultConstant) {
        return Promise.resolve(null)
      }
      return Promise.resolve({ options: options, matched: matched, defaultType: defaultConstant.code })
    },
    // 根据配置确定发票类型默认值：
    // 1. 单选：默认值 = 勾选数据费用税率命中的配置发票类型（税率精确匹配，配置驱动）
    // 2. 批量：默认值 = 匹配组合中税率最大值（9% 除外）对应的类型 / 用户确认统一的类型
    // 默认值仅当下拉数据源包含该类型时才应用；无配置时不会进入本方法（原有逻辑）
    applyDefaultInvoiceTypeByConfig() {
      if (!this.taxInvoiceConfigLoaded || this.taxInvoiceConfigCombos.length === 0) {
        return
      }
      if (this.taxInvoiceConfigBatchApplied) {
        // 批量式匹配结果（含单选一条数据下多税率场景）：默认值 = 税率最大值（9% 除外）/ 用户确认统一的类型（重放时一致）
        const option = this.taxInvoiceConfigOptions.find(item => item.code === this.taxInvoiceConfigDefaultType) || this.taxInvoiceConfigOptions[0]
        // 仅当默认值存在于当前下拉数据源时才应用（非全电接口走纸质/增值票数据源，配置的 6/7 全电类型不注入）
        if (!option || !this.invoiceTypeOptions.some(item => item.code === option.code)) {
          return
        }
        this.properties.invoiceType = option.code
        this.invoiceTypeChange(this.properties.invoiceType)
        return
      }
      // 单选：taxInvoiceConfigCombos 已按勾选数据费用税率过滤，直接采用命中配置的发票类型
      const matchedTypes = []
      this.taxInvoiceConfigCombos.forEach(combo => {
        if (!matchedTypes.includes(combo.invoiceType)) matchedTypes.push(combo.invoiceType)
      })
      let nextInvoiceType = null
      if (matchedTypes.length === 1) {
        nextInvoiceType = matchedTypes[0]
      } else if (matchedTypes.length > 1) {
        // 同税率命中多种发票类型（跨结算对象合并场景）：6% 含专票优先专票，否则默认普票，避免不确定性
        nextInvoiceType = this.taxInvoiceConfigCombos.some(combo =>
          Number(combo.taxRate) === 6 && combo.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code)
          ? InvoiceConstant.INVOICE_TYPE_VAT_FEI.code
          : InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code
      }
      if (this.invoiceTypeOptions.some(item => item.code === nextInvoiceType)) {
        this.properties.invoiceType = nextInvoiceType
        this.invoiceTypeChange(this.properties.invoiceType)
      }
    },
    resetInvoiceTypeByTaxRate() {
      if (!this.properties || !this.properties.isAr) {
        return
      }
      const allEntities = Array.isArray(this.properties.allEntities) ? this.properties.allEntities : []
      if (allEntities.length === 0) {
        return
      }
      const taxRates = []
      allEntities.forEach(charge => {
        if (!charge) return false
        const rawTaxRate = charge.taxRate !== undefined && charge.taxRate !== null && charge.taxRate !== ''
          ? charge.taxRate
          : charge.chargeTaxRate
        if (rawTaxRate === undefined || rawTaxRate === null || rawTaxRate === '') {
          return false
        }
        const taxRateValue = Number(String(rawTaxRate).replace('%', '').replace(/[^\d.-]/g, '').trim())
        if (!Number.isNaN(taxRateValue)) {
          taxRates.push(taxRateValue)
        }
      })
      if (taxRates.length === 0) {
        return
      }
      const hasNotZeroTaxRate = taxRates.some(rate => rate > 0)
      // 业务要求：0税=电子发票-普通发票(7)，>0税=电子发票-增值税专用发票(6)
      const nextInvoiceType = hasNotZeroTaxRate
        ? InvoiceConstant.INVOICE_TYPE_VAT_FEI.code
        : InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code
      this.properties.invoiceType = nextInvoiceType
      this.invoiceTypeChange(this.properties.invoiceType)
    },
    changeInvoiceType() { // 调整发票类型下拉框数据源
      this.isFei = this.properties && this.properties.groupingMakeType === 1 && (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || this.properties.toExoSystemYGSH)
      this.isNuoNuo = this.isFei && this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO
    },
    rateTipHC() {
      this.restrictionHC = false
      // 当海创参数开启时，如果存在9税 不可以和其他税率一起开票
      if (this.properties.toExoSystemHC && this.properties.allEntities && this.properties.isAr) {
        const taxRates = new Set()
        let has = false
        let hasNormalInvoiceTaxRate = false
        for (const data of this.properties.allEntities) {
          if (data.entity === 'charge' || [1, 2].includes(this.properties.makeInvoiceMethod)) {
            if (data.taxRate === 9) {
              has = true
            }
            if ([0, 6].includes(data.taxRate)) {
              hasNormalInvoiceTaxRate = true
            }
            taxRates.add(data.taxRate)
          }
        }
        if (taxRates.size > 1 && has) {
          this.$alert(this.$t('CargoMsg.Cargo_CurrentSelectionContains9TaxPointsAndOthers'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('Clearing.Confirm'),
            type: 'warning',
            callback: action => {
              this.cancel()
            }
          })
        }
        if (has || hasNormalInvoiceTaxRate) {
          // 海创按税率优化特定约束类型：0/6=正常发票，9=货物运输服务
          // 发票类型由 resetInvoiceTypeByTaxRate 统一决定，这里不再覆盖
          this.invoiceTypeChange(this.properties.invoiceType)
          if (has) {
            this.properties.specificConstraintType = InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_CTS.code
            this.restrictionHC = true
          } else if (taxRates.size > 0) {
            this.properties.specificConstraintType = InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_NI.code
          }
        } else {
          this.properties.specificConstraintType = InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_NI.code
        }
      }
    },
    btnSetupHandler() {
      if (this.commandCode === this.$t('CargoMsg.Cargo_InvoiceChargeItemSetup')) {
        this.invoiceChargeItemDialog.visible = true
      } else if (this.commandCode === this.$t('CargoMsg.Cargo_InvoiceChargeUnitSetup')) {
        this.invoiceChargeUnitDialog.visible = true
      }
    },
    // ============ 以下方法合并自 makeInvoiceStepTwoDialog（去掉所有 ag-grid 依赖）============
    // 折合汇率1变更
    txtRate1Change(value) {
      console.log('txtRate1Change:', value)
      const rate = StrUtils.isEmpty(value) ? 0 : value
      this.properties.txtRate1 = NumberUtils.formatRoundNumber(rate, 8)
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const charge of this.properties.allEntities) {
          if (charge.currency === this.properties.txtCurrency1) {
            charge.invoiceRate = this.properties.txtRate1
            charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
          }
        }
      }
      this.reCalcSupInvoiceAmount2(makeInvoiceMethod)
      // 刷新合计
      this.reSetChargeCurrencyTotalGroup()
    },
    // 折合汇率2变更（修复原 Step2 中 this.this. 的拼写错误）
    txtRate2Change(value) {
      console.log('txtRate2Change:', value)
      const rate = StrUtils.isEmpty(value) ? 0 : value
      this.properties.txtRate2 = NumberUtils.formatRoundNumber(rate, 8)
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const charge of this.properties.allEntities) {
          if (charge.currency === this.properties.txtCurrency2) {
            charge.invoiceRate = this.properties.txtRate2
            charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
          }
        }
      }
      this.reCalcSupInvoiceAmount2(makeInvoiceMethod)
      // 刷新合计（原 Step2 此处为 this.this.reSetChargeCurrencyTotalGroup()，已修正）
      this.reSetChargeCurrencyTotalGroup()
    },
    // 折合重算（无 ag-grid，仅通过 reCalc 触发组件重渲染）
    reSetChargeCurrencyTotalGroup() {
      setTimeout(() => { this.reCalc = false }, 100)
      setTimeout(() => { this.reCalc = true }, 100)
    },
    // 汇率变更后重新汇总父级 invoiceAmount2（按账单/对账单/付款申请单）
    reCalcSupInvoiceAmount2(makeInvoiceMethod) {
      if ([3, 4, 5].includes(makeInvoiceMethod)) {
        const invoiceAmountMap = new Map()
        for (const charge of this.properties.allEntities) {
          if (charge['entity'] === 'charge') {
            let uuid = ''
            if (makeInvoiceMethod === 3) {
              uuid = charge['billingUuid']
            } else if (makeInvoiceMethod === 4) {
              uuid = charge['billingGroupUuid']
            } else if (makeInvoiceMethod === 5) {
              uuid = charge['billingPaymentUuid']
            }
            if (invoiceAmountMap.has(uuid)) {
              invoiceAmountMap.set(uuid, RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2, this.properties.currency))
            } else {
              invoiceAmountMap.set(uuid, (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
            }
          }
        }
        for (const item of this.properties.allEntities) {
          if (item['entity'] !== 'charge' && item.entity !== undefined) {
            item['amount'] = ''
            item['excludingTaxAmount'] = ''
            item['invoiceRate'] = ''
            item['invoiceAmount2'] = ''
          }
          let uuid = ''
          if (item['entity'] === 'billing' && makeInvoiceMethod === 3) {
            uuid = item['billingUuid']
          } else if (item['entity'] === 'billingGroup' && makeInvoiceMethod === 4) {
            uuid = item['billingGroupUuid']
          } else if (item['entity'] === 'billPayment' && makeInvoiceMethod === 5) {
            uuid = item['billingPaymentUuid']
          }
          if (invoiceAmountMap.has(uuid)) {
            item['invoiceAmount2'] = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid), this.properties.currency), 2)
          }
        }
      }
    },
    prepareChargeSplit(action) {
      const charges = this.invoiceCharges.filter(item => item && (item.entity === 'charge' || item.entity === undefined))
      if (charges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit'))
        return
      }
      if (charges.length === 1) {
        this.selectedCharge = charges[0]
        this.openChargeSplitAction(action)
        return
      }
      this.splitChargeSelectDialog.action = action
      this.splitChargeSelectDialog.rowData = charges.map(charge => {
        return Object.assign({}, charge, {
          chargeName: charge.chargeName || ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId, 'zhName')
        })
      })
      this.splitChargeSelectDialog.currentRow = null
      this.splitChargeSelectDialog.visible = true
    },
    confirmChargeSplitSelection() {
      if (!this.splitChargeSelectDialog.currentRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit'))
        return
      }
      const selectedUuid = this.splitChargeSelectDialog.currentRow.uuid
      this.selectedCharge = this.invoiceCharges.find(charge => charge.uuid === selectedUuid) || this.splitChargeSelectDialog.currentRow
      this.splitChargeSelectDialog.visible = false
      this.openChargeSplitAction(this.splitChargeSelectDialog.action)
    },
    openChargeSplitAction(action) {
      if (action === 'auto') {
        this.toAutoSplitCharge()
      } else {
        this.toSplitCharge()
      }
    },
    validateSelectedChargeCanSplit(charge) {
      if (!charge || Object.keys(charge).length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit'))
        return false
      }
      if (charge.verifiedAmount !== 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NonSplitWriteOffExpense'))
        return false
      }
      if (this.hmToFinanceApi && charge.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
        this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
        return false
      }
      return true
    },
    toSplitCharge() {
      if (!this.validateSelectedChargeCanSplit(this.selectedCharge)) {
        return
      }
      this.splitChargeDialog.chargeOrigin = this.selectedCharge
      this.splitChargeDialog.charge = { ...this.selectedCharge }
      this.splitChargeDialog.charge.chargeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', this.splitChargeDialog.charge.chargeItemId, 'zhName')
      this.splitChargeDialog.charge.amount = NumberUtils.formatRoundNumber(this.splitChargeDialog.charge.amount, 2)
      this.splitChargeDialog.splitCharge.chargeName = this.splitChargeDialog.charge.chargeName
      this.splitChargeDialog.splitCharge.currency = this.splitChargeDialog.charge.currency
      this.splitChargeDialog.splitCharge.taxRate = this.splitChargeDialog.charge.taxRate
      this.splitChargeDialog.splitCharge.amount = 0.0
      this.splitChargeDialog.splitCharge.taxAmount = 0.0
      this.splitChargeDialog.splitCharge.excludingTaxAmount = 0.0
      this.splitChargeDialog.btnSplitEnable = false
      this.splitChargeDialog.onlyChangeQuantity = LocalStorageUtilsNew.hasConfiguration('splitChargeOnlyChangeQuantity') ? Boolean(LocalStorageUtilsNew.getConfiguration('splitChargeOnlyChangeQuantity')) : true
      this.splitChargeDialog.show = true
    },
    amountChangeHandler(value) {
      this.splitChargeDialog.splitCharge.amount = RateUtil.getAmountByCurrency(value, this.splitChargeDialog.splitCharge.currency)
      this.splitChargeDialog.charge.amount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.chargeOrigin.amount - this.splitChargeDialog.splitCharge.amount, this.splitChargeDialog.splitCharge.currency), 2)
      const rAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.amount / (this.splitChargeDialog.splitCharge.taxRate / 100 + 1), this.splitChargeDialog.splitCharge.currency), 2)
      this.splitChargeDialog.splitCharge.excludingTaxAmount = rAmount
      this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.amount - rAmount, this.splitChargeDialog.splitCharge.currency), 2)
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.splitChargeDialog.splitCharge.amount -
          this.splitChargeDialog.splitCharge.excludingTaxAmount -
          this.splitChargeDialog.splitCharge.taxAmount, 6), this.splitChargeDialog.splitCharge.currency)
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.taxAmount + c, this.splitChargeDialog.splitCharge.currency), 2)
        }
      }
    },
    doSplitCharge() {
      this.splitChargeDialog.btnSplitEnable = true
      if (this.splitChargeDialog.splitCharge.amount === 0) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterSplitAmount'))
        return
      } else if (this.splitChargeDialog.charge.quantity > 1 && !this.splitChargeDialog.onlyChangeQuantity) {
        this.$confirm(this.$t('CargoMsg.Cargo_NOEGT1ICTSTNWBST1C'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.doSplit()
        }).catch(() => {
          this.splitChargeDialog.btnSplitEnable = false
        })
      } else {
        this.doSplit()
      }
    },
    doSplit() {
      if (this.splitChargeDialog.splitCharge.amount > this.splitChargeDialog.chargeOrigin.amount && this.properties.costInfo) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('Message.TipsOnSplittingExpenses'))
        return
      }
      this.splitChargeDialog.splitCharge.quantity = 1
      this.splitChargeDialog.splitCharge.billingAmount = 0
      this.splitChargeDialog.splitCharge.unitRate = this.splitChargeDialog.splitCharge.excludingTaxAmount
      const rAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.amount / (this.splitChargeDialog.charge.taxRate / 100 + 1), this.splitChargeDialog.splitCharge.currency), 2)
      this.splitChargeDialog.charge.excludingTaxAmount = rAmount
      this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.amount - rAmount, this.splitChargeDialog.splitCharge.currency), 2)
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.splitChargeDialog.charge.amount -
          this.splitChargeDialog.charge.excludingTaxAmount -
          this.splitChargeDialog.charge.taxAmount, 6), this.splitChargeDialog.splitCharge.currency)
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.taxAmount + c, this.splitChargeDialog.splitCharge.currency), 2)
        }
      }
      this.splitChargeDialog.charge.quantity = 1
      this.splitChargeDialog.charge.unitRate = this.splitChargeDialog.charge.excludingTaxAmount
      this.splitChargeDialog.charge.chargeSource = this.properties.makeInvoiceMethod
      this.splitChargeDialog.splitCharge.chargeSource = this.properties.makeInvoiceMethod
      if (this.properties.makeInvoiceMethod === 4) {
        this.splitChargeDialog.charge.invoiceUuid = this.splitChargeDialog.charge.billingGroupUuid
        this.splitChargeDialog.splitCharge.invoiceUuid = this.splitChargeDialog.charge.billingGroupUuid
      }
      this.splitChargeDialog.charge.splitChargeOnlyChangeQuantity = this.splitChargeDialog.onlyChangeQuantity
      this.saveMergedSplitCharges([this.splitChargeDialog.charge, this.splitChargeDialog.splitCharge], () => {
        this.splitChargeDialog.show = false
        this.splitChargeDialog.btnSplitEnable = false
      }, () => {
        this.splitChargeDialog.btnSplitEnable = false
      })
    },
    toAutoSplitCharge() {
      if (!this.validateSelectedChargeCanSplit(this.selectedCharge)) {
        return
      }
      this.autoSplitChargeDialog.confirmSplitEnable = true
      this.autoSplitChargeDialog.maxAmount = 0.0
      this.autoSplitChargeDialog.rowData = []
      this.autoSplitChargeDialog.chargeOrigin.chargeSource = this.properties.makeInvoiceMethod
      this.autoSplitChargeDialog.chargeOrigin.sequenceNumber = 1
      this.autoSplitChargeDialog.chargeOrigin.uuid = this.selectedCharge.uuid
      this.autoSplitChargeDialog.chargeOrigin.chargeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', this.selectedCharge.chargeItemId, 'zhName')
      this.autoSplitChargeDialog.chargeOrigin.amount = this.selectedCharge.amount
      this.autoSplitChargeDialog.chargeOrigin.currency = this.selectedCharge.currency
      this.autoSplitChargeDialog.chargeOrigin.taxRate = this.selectedCharge.taxRate
      this.autoSplitChargeDialog.chargeOrigin.taxAmount = this.selectedCharge.taxAmount
      this.autoSplitChargeDialog.chargeOrigin.excludingTaxAmount = this.selectedCharge.excludingTaxAmount
      this.autoSplitChargeDialog.chargeOrigin.quantity = this.selectedCharge.quantity || 1
      this.autoSplitChargeDialog.chargeOrigin.unitRate = this.selectedCharge.unitRate || this.selectedCharge.excludingTaxAmount
      this.autoSplitChargeDialog.chargeOrigin.jobUuid = this.selectedCharge.jobUuid
      if (this.properties.makeInvoiceMethod === 4) {
        this.autoSplitChargeDialog.chargeOrigin.billingGroupUuid = this.selectedCharge.billingGroupUuid
      }
      this.autoSplitChargeDialog.visible = true
    },
    toAutoCalculateSplit() {
      if (!this.autoSplitChargeDialog.maxAmount || this.autoSplitChargeDialog.maxAmount < 0) {
        this.$message.warning(this.$t('Message.TipsOnAutoSplittingCharge'))
        return
      }
      if (this.autoSplitChargeDialog.maxAmount >= this.autoSplitChargeDialog.chargeOrigin.amount) {
        this.$message.warning(this.$t('Message.TipsOnSplittingExpenses'))
        return
      }
      const chargeOrigin = this.autoSplitChargeDialog.chargeOrigin
      const rowData = []
      const newOriginCharge = { ...chargeOrigin }
      newOriginCharge.amount = this.autoSplitChargeDialog.maxAmount
      newOriginCharge.unitRate = roundHalfUp(newOriginCharge.amount / (newOriginCharge.taxRate / 100 + 1) / newOriginCharge.quantity, 2)
      newOriginCharge.excludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newOriginCharge.unitRate * newOriginCharge.quantity, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
      newOriginCharge.taxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newOriginCharge.amount - newOriginCharge.excludingTaxAmount, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
      this.fixAutoSplitTaxAmountCarry(newOriginCharge)
      if (this.properties.makeInvoiceMethod === 4) {
        newOriginCharge.invoiceUuid = newOriginCharge.billingGroupUuid
      }
      rowData.push(newOriginCharge)
      const len = Math.ceil((chargeOrigin.amount - this.autoSplitChargeDialog.maxAmount) / this.autoSplitChargeDialog.maxAmount)
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          const newCharge = { ...chargeOrigin }
          newCharge.uuid = ''
          newCharge.sequenceNumber = newCharge.sequenceNumber + i + 1
          newCharge.amount = i < len - 1 ? this.autoSplitChargeDialog.maxAmount : roundHalfUp(chargeOrigin.amount - this.autoSplitChargeDialog.maxAmount * len, 2)
          newCharge.quantity = 1
          newCharge.unitRate = roundHalfUp(newCharge.amount / (newCharge.taxRate / 100 + 1) / newCharge.quantity, 2)
          newCharge.excludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newCharge.unitRate * newCharge.quantity, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
          newCharge.taxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newCharge.amount - newCharge.excludingTaxAmount, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
          newCharge.billingAmount = 0.0
          this.fixAutoSplitTaxAmountCarry(newCharge)
          if (this.properties.makeInvoiceMethod === 4) {
            newCharge.invoiceUuid = newCharge.billingGroupUuid
          }
          rowData.push(newCharge)
        }
      }
      this.autoSplitChargeDialog.confirmSplitEnable = false
      this.autoSplitChargeDialog.rowData = rowData
    },
    fixAutoSplitTaxAmountCarry(charge) {
      if (!RateUtil.useAmountCarryRule()) return
      const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.amount -
        charge.excludingTaxAmount -
        charge.taxAmount, 6), this.autoSplitChargeDialog.chargeOrigin.currency)
      if (Math.abs(c) !== 0) {
        charge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.taxAmount + c, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
      }
    },
    doAutoSplitCharge() {
      if (!this.autoSplitChargeDialog.maxAmount || this.autoSplitChargeDialog.rowData.length === 0) {
        return
      }
      this.saveMergedSplitCharges(this.autoSplitChargeDialog.rowData, () => {
        this.autoSplitChargeDialog.confirmSplitEnable = true
        this.autoSplitChargeDialog.maxAmount = 0.0
        this.autoSplitChargeDialog.rowData = []
        this.autoSplitChargeDialog.visible = false
      })
    },
    saveMergedSplitCharges(charges, successCallback, errorCallback) {
      this.loading = getLoading()
      saveSplitCharge(charges, this.location).then(async res => {
        const splitCharges = Array.isArray(res.data) ? res.data : []
        this.properties.entities = mergeInvoiceSplitCharges(this.properties.entities, splitCharges)
        this.properties.allEntities = mergeInvoiceSplitCharges(this.properties.allEntities, splitCharges)
        await this.checkState()
        this.reSetChargeCurrencyTotalGroup()
        this.$message.success(this.$t('CargoMsg.Cargo_SplitSuccessfully'))
        if (successCallback) successCallback()
      }).catch(() => {
        if (errorCallback) errorCallback()
      }).finally(() => {
        this.loading.close()
      })
    },
    maxAmountChangeHandler(value) {
      this.autoSplitChargeDialog.maxAmount = RateUtil.getAmountByCurrency(value, this.autoSplitChargeDialog.chargeOrigin.currency)
    },
    onlyChangeQuantityChangeHandler() {
      LocalStorageUtilsNew.setConfiguration('splitChargeOnlyChangeQuantity', this.splitChargeDialog.onlyChangeQuantity)
    },
    // 获取账单所对应的结算单位
    getTitleMap() {
      const map = {}
      if (this.properties.makeInvoiceMethod === 3) {
        for (const billing of this.properties.selectedEntities) {
          map[billing.uuid] = billing.title
        }
      }
      return map
    },
    // 确认是否应当添加账单中的开票需求
    getClassType() {
      switch (this.properties.makeInvoiceMethod) {
        case 1:
        case 2:
          return 'charge'
        case 3:
          return 'billing'
        case 4:
          return 'billingGroup'
        case 5:
          return 'billPayment'
      }
      return ''
    },
    // 生成发票（数据源从 ag-grid 选择改为 properties.allEntities 全部选中）
    async generate() {
      const selectedEntities = this.invoiceCharges
      if (selectedEntities.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if ((!StrUtils.isEmpty(this.properties.txtCurrency1) && StrUtils.isEmpty(this.properties.txtRate1)) ||
        (!StrUtils.isEmpty(this.properties.txtCurrency2) && StrUtils.isEmpty(this.properties.txtRate2))) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExchangeRateCanTBeEmpty'))
        return
      }
      this.properties.otherRates = []
      if (this.properties.otherCurrencys.length > 2) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NECDFTIC').format(2))
        return
      } else if (this.properties.otherCurrencys.length > 0) {
        const n1 = parseFloat(this.properties.txtRate1)
        if (!this.properties.txtRate1 || n1 === 0) {
          this.$message.warning(this.$t('Message.PleaseEnterCurrencyExchangeRate'))
          return
        }
        this.properties.otherRates.push(this.properties.txtRate1)
        if (this.properties.otherCurrencys.length > 1) {
          const n2 = parseFloat(this.properties.txtRate2)
          if (!this.properties.txtRate2 || n2 === 0) {
            this.$message.warning(this.$t('Message.PleaseEnterCurrencyExchangeRate'))
            return
          }
          this.properties.otherRates.push(this.properties.txtRate2)
        }
      }
      if (this.unInvoiceCreate && this.properties.invoices) {
        for (const invoice of this.properties.invoices) {
          if (!invoice.invoiceNo || !invoice.title) {
            this.$message.warning(this.$t('CargoMsg.Cargo_MustInvoiceNoAndTitle'))
            return
          }
        }
      }
      for (const item of selectedEntities) {
        if (item.chargeBusinessQuotationAmount > 0 && !item.chargeBusinessQuotationConfirmd) {
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId)
          this.$message.warning(this.$t('CargoMsg.Cargo_UnconfirmedSum', [item.jobNo, chargeItem.zhName, item.currency, item.amount]))
          return
        }
      }
      // 接口中开票类型：mode
      this.properties.mode = this.properties.typeGroup
      // 单步流程移除了部分开票选项 checkbox(showChargeDetail / isInvoicingByBillingRate 等)。后端 InvoiceFasterUtil.generate
      // 读取这些字段时部分无 null 兜底,这里统一补默认 false,避免后端拆箱 NPE:
      //   - showChargeDetail: 后端 :269 已加兜底;此处仍补 false 作前端侧保险(后端重新编译生效后可删)。
      //   - isInvoicingByBillingRate: 后端 :891 仅在 invoiceByType==='billing'(按账单)时拆箱,前端补 false 规避。
      if (this.properties.showChargeDetail == null) {
        this.properties.showChargeDetail = false
      }
      if (this.properties.isInvoicingByBillingRate == null) {
        this.properties.isInvoicingByBillingRate = false
      }
      this.properties.titleMap = this.getTitleMap()
      this.properties.invoiceByType = this.getClassType()
      this.properties.hedgeInvoiceByType = this.getClassType()
      // 开票-勾选展示销售方银行账号可以自动根据上次操作默认勾选或取消勾选
      if ((this.properties.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || this.properties.invoiceType === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) && LocalStorageUtilsNew.hasConfiguration('invoiceDisplaySell')) {
        this.properties.invoiceDisplaySell = LocalStorageUtilsNew.getConfiguration('invoiceDisplaySell')
      }
      //
      const allCharges = []
      const chargeMap = {}
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const item of selectedEntities) {
          const charges = []
          if (item['entity'] === 'charge' || item.entity === undefined) {
            allCharges.push(item)
            if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2) {
              charges.push(item.uuid)
              chargeMap['charge-' + item.uuid] = charges
            }
            if (makeInvoiceMethod === 3) {
              if (!chargeMap.hasOwnProperty('billing-' + item.billingUuid)) {
                chargeMap['billing-' + item.billingUuid] = []
              }
              chargeMap['billing-' + item.billingUuid].push(item.uuid)
            } else if (makeInvoiceMethod === 4) {
              if (!chargeMap.hasOwnProperty('billingGroup-' + item.billingGroupUuid)) {
                chargeMap['billingGroup-' + item.billingGroupUuid] = []
              }
              chargeMap['billingGroup-' + item.billingGroupUuid].push(item.uuid)
            } else if (makeInvoiceMethod === 5) {
              if (!chargeMap.hasOwnProperty('billPayment-' + item.billingPaymentUuid)) {
                chargeMap['billPayment-' + item.billingPaymentUuid] = []
              }
              chargeMap['billPayment-' + item.billingPaymentUuid].push(item.uuid)
            }
          }
        }
      }
      if (allCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFNBFSWWF'))
        return
      }
      this.properties.allCharges = allCharges
      this.properties.chargeMap = chargeMap
      await this.doPreGenerateInvoiceFaster()
    },
    // 执行生成发票操作（OJ 校验规则门禁）
    async doPreGenerateInvoiceFaster() {
      if (String(cache.config.get('ToExoSystem')) === 'OJ') {
        const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code, this.$store.getters.currentOfficeId)
        if (useCheckRule && checkNodeFlag) {
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code
          const result = await this.checkNodeResult()
          if (result.needShowDialog) {
            this.batchCheckingWindow.jobs = result.jobList
            this.batchCheckingWindow.resData = result.resData
            this.batchCheckingWindow.callBack = this.toGenerateInvoiceFaster
            this.batchCheckingWindow.callBack2 = null
            this.batchCheckingWindow.visible = true
          } else {
            await this.toGenerateInvoiceFaster()
          }
        } else {
          await this.toGenerateInvoiceFaster()
        }
      } else {
        await this.toGenerateInvoiceFaster()
      }
    },
    // 校验是否全部通过验证，是则跳过
    async checkNodeResult() {
      const result = { needShowDialog: false, jobList: [], resData: [] }
      this.properties.allCharges.forEach((item) => {
        result.jobList.push({ lob: item.jobLob, chargeUuid: item.uuid, jobNo: item.jobNo, jobUuid: item.jobUuid })
      })
      const data = {
        checkNode: CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code,
        chargeUuidList: result.jobList.map(item => item.chargeUuid),
        branchId: this.$store.getters.currentOfficeId,
        paymentMethod: this.properties.isAr,
        taxRate: this.properties.invoiceGoodsName ? this.properties.invoiceGoodsName.taxRate : 0,
        entities: this.properties.invoices
      }
      let needShowDialog = false
      await checkChargeByInvoiceSaveNode(data).then(res => {
        result.resData = res.data || []
        if (result.resData) {
          for (const key of Object.keys(result.resData)) {
            for (const item of result.resData[key]) {
              if (item.expressions) {
                for (const express of item.expressions) {
                  if (!express.match) {
                    needShowDialog = true
                    break
                  }
                }
              }
            }
            if (needShowDialog) {
              break
            }
          }
        }
      })
      result.needShowDialog = needShowDialog
      return result
    },
    // 生成发票
    toGenerateInvoiceFaster() {
      if (this.properties && this.properties.invoiceGoodsNameList) {
        this.properties.invoiceGoodsNameList = []
      }
      this.properties.unInvoiceCreate = false
      this.properties.isFei = this.properties && this.properties.groupingMakeType === 1 && (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || this.properties.toExoSystemYGSH)
      const requestBody = { 'chargeMap': this.properties.chargeMap, 'properties': this.properties, 'location': this.location }
      const loading = getLoading4Cxt(this.$el)
      if (this.unInvoiceCreate) {
        // 收票必须填写发票号/抬头：与 Step2 一致，走 saveInvoiceFasterFunc（保存而非仅生成）。
        // 注意：computed unInvoiceCreate = apInvoiceCreateMusthaveTitileAndNumber && isCollectInvoice，
        // 与上面 this.properties.unInvoiceCreate = false 的赋值无关，收票模式下此分支仍可触发。
        // 注意：合并后的单步流程未迁入 showCollectInvoiceWindow 预填子弹窗（见 MERGE_AUDIT 收票缺口），
        // 收票(⑧⑨/应付 method1-4)在 APInvoiceCreateMusthaveTitileAndNumber=1 下的完整预填-保存流程需另行补齐。
        saveInvoiceFasterFunc(requestBody).then(res => {
          console.log('saveInvoiceFasterFunc', res.data)
          this.properties.invoices = res.data
          this.$emit('generatedHandler', 'step3')
        }).finally(() => {
          loading.close()
        })
      } else {
        generateInvoiceFaster(requestBody).then(res => {
          console.log('generateInvoiceFaster', res.data)
          this.properties.invoices = res.data
          this.$emit('generatedHandler', 'step3')
        }).finally(() => {
          loading.close()
        })
      }
    }
  }
}
</script>

<style lang="scss">
.make-invoice-step-one-dialog {
  .el-dialog__body {
    padding: 10px !important;
    min-height: 450px;
  }
  .custom-radio-group {
    label {
      display: block;
      margin-bottom: 10px;
    }
    label:first-child {
      padding-top: 5px;
    }
    label:last-child {
      margin-bottom: 0;
    }
    inlineWarp {
      display: inline-block;
    }
  }
}
</style>
